export const FETCH_DEVICES_POSITIONS = 'FETCH_DEVICES_POSITIONS';
export const DELETE_POSITION = 'DELETE_POSITION';
